import React from "react";
import { Form } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import _ from "lodash";

class ChatForm extends React.Component {
  state = {
    username: this.props.username,
    readOnly: this.props.readOnly,
    content: "",
    error: false,
  };

  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (this.state.content) {
        this.handleSubmit();
      }
    }
  };

  handleSubmit = (e) => {
    const { username, content, readOnly } = this.state;
    if (_.isEmpty(username) || username === "null" || readOnly) {
      if (!_.isNull(this.props.popUpFunctionName)) {
        this.setState({ error: true });
        window.parent.postMessage(
          {
            func: this.props.popUpFunctionName,
            message: "open_name_popup",
          },
          "*"
        );
      }
    } else if (_.isEmpty(content)) {
      this.setState({ error: true });
    } else {
      this.props.addComment(content);
      this.setState({ content: "", error: false });
    }
  };

  render() {
    const { content, error } = this.state;

    return (
      <Form onSubmit={this.handleSubmit}>
        <Form.Group>
          <Form.Input
            autoComplete="off"
            error={error}
            className="comment-field"
            placeholder={this.props.placeholder}
            name="content"
            value={content}
            onChange={this.handleChange}
            onKeyDown={this.handleKeyDown}
            maxLength={500}
          />
          <Form.Button
            circular
            className="comment-send-button"
            icon="send"
            size="mini"
          />
        </Form.Group>
      </Form>
    );
  }
}

export default withTranslation()(ChatForm);
